import meta from "@/public/icons/meta.svg";
import vastal from "@/public/icons/teams/vastal_11zon.png";
import aws from "@/public/icons/aws-logoo.svg";
import vyas from "@/public/icons/teams/vyas_11zon.png";
import mckin from "@/public/icons/mck-logo-new.svg";
import shirom from "@/public/icons/teams/shirom_11zon.png";
import metas from "@/public/icons/meta-switch-icone.svg";
import adian from "@/public/icons/teams/adian_11zon.png";
import tadas from "@/public/icons/teams/tadas_11zon.png";
import anim from "@/public/icons/anim.svg";
import brave from "@/public/icons/brave-black.svg";
import ada from "@/public/icons/teams/ada_11zon.png";
import brandon from "@/public/icons/teams/brandon_11zon.png";
import verizon from "@/public/icons/verizon.svg";
import gin from "@/public/icons/teams/gin_11zon.png";
import atlas from "@/public/icons/atlas.svg";
// import serge from "@/public/icons/serge.svg"
// import war from "@/public/icons/war.svg";
import piotr from "@/public/icons/teams/piotr_11zon.png";

import jamesRayan from "@/public/imgs/team/jamesRayan.png";
import nadzeya from "@/public/imgs/team/nadzeya.png";
import wayneDeLeon from "@/public/imgs/team/wayneDeLeon.png";
import richRobinson from "@/public/imgs/team/richRobinson.png";
import paulius from "@/public/imgs/team/paulius.png";
// import sergej from "@/public/icons/ourTeam/sergej.svg";
import adi from "@/public/imgs/team/adi.png";
import akash from "@/public/imgs/team/akash.png";
import yousefAtout from "@/public/imgs/team/yousefAtout.png";
import jaykrushna from "@/public/imgs/team/jaykrushna.png";
import johnMelad from "@/public/imgs/team/johnMelad.png";
import jasonKinyyaev from "@/public/imgs/team/jasonKinyyaev.png";
import sergiiKovsch from "@/public/imgs/team/sergiiKovsch.png";
import yekebulan from "@/public/imgs/team/yekebulan.png";
import mohammad from "@/public/imgs/team/mohammad.png";
import romanNovikov from "@/public/imgs/team/romanNovikov.png";
import lucasGuimaraes from "@/public/imgs/team/lucasGuimaraes.png";
import hamzaWahab from "@/public/imgs/team/hamzaWahab.png";
import flaviu from "@/public/imgs/team/flaviu.png";
import domitri from "@/public/imgs/team/domitri.png";
import romanKulik from "@/public/imgs/team/romanKulik.png";
import mohammadFurqan from "@/public/imgs/team/mohammadFurqan.png";
import kapustin from "@/public/imgs/team/kapustin.png";
import romanStratev from "@/public/imgs/team/romanStratev.png";
import ahmadUsman from "@/public/imgs/team/ahmadUsman.png";
import mohammadUsama from "@/public/imgs/team/mohammadUsama.png";
import muzzamil from "@/public/imgs/team/muzzamil.png";
import abdullah from "@/public/imgs/team/abdullah.png";
import carlosEncarnacion from "@/public/imgs/team/carlosEncarnacion.png";
import dominicRohde from "@/public/imgs/team/dominicRohde.png";
import adam from "@/public/imgs/team/adam.png";
import nejc from "@/public/imgs/team/nejc.png";
// import dafault from "@/public/icons/ourTeam/userDefault.png";
import dafault from "@/public/icons/ourTeam/user-gray.png";

export const CONTENTS1 = [
  {
    id: 1,
    title: "Vatsal Raina",
    subtitle: "Chief Technology Officer",
    content: `Vatsal, a top 1% graduate in  information engineering from Cambridge who holds a PhD from the  <span class="font-bold"> Machine Intelligence Laboratory</span>. Vatsal previously worked at <span class="font-bold">Meta</span> where he collaborated with exceptional researchers who shaped <span class="font-bold">Llama 2 </span> and <span class="font-bold">RAG development</span>. `,
    icon: vastal,
    href: "https://www.linkedin.com/in/vatsal-raina-497a48139/",
    company: {
      src: meta,
      width: 69,
      height: 15,
    },
  },

  {
    id: 2,
    title: "Vyas Raina",
    subtitle: "Lead Ai Director",
    content: `Vyas Raina, a top 2% Cambridge engineering graduate with a PhD, has excelled as a research scientist at <span class="font-bold"> Amazon Web Services</span> and <span class="font-bold"> Lead NLP researcher at Schonfeld</span> , contributing extensively to machine learning and NLP.`,
    icon: vyas,
    href: "https://www.linkedin.com/in/vyas-raina-71b226152/",
    company: {
      src: aws,
      width: 32,
      height: 32,
    },
  },

  {
    id: 3,
    title: "Shirom Chabra",
    subtitle: "Chief Executive Officer",
    content: `Shirom, a top 2% Cambridge graduate who holds a PhD in computational biology, who previously worked at <span class="font-bold">  McKinsey & Company </span>in London. `,
    icon: shirom,
    href: "https://www.linkedin.com/in/shirom-chabra/",
    company: {
      src: mckin,
      width: 75,
      height: 24,
    },
  },

  {
    id: 4,
    title: "Adian Liusie",
    subtitle: "Lead AI Director",
    content: `Adian Liusie, a top 3% Cambridge AI PhD graduate, has made significant contributions to AI research and security at <span class="font-bold"> Microsoft</span>  and startups like  <span class="font-bold"> Sambanova</span> , with notable publications including  <span class="font-bold"> 'SelfCheckGPT'</span> .`,
    icon: adian,
    href: "https://www.linkedin.com/in/adian-liusie-00b60511a/",
    company: {
      src: metas,
      width: 90,
      height: 26,
    },
  },
  {
    id: 5,
    title: "Piotr Molenda",
    subtitle: "AI/ML Engineer",
    content: `A top Cambridge masters in engineering graduate, with a focus on electrical, information, and control systems, specializing in machine learning and AI. Piotr has experience in developing watermarking for large language models.`,
    icon: piotr,
    href: "https://www.linkedin.com/in/piotr-molenda-10180b248/?original_referer=",
  },
  {
    id: 6,
    title: "Adam Liusie",
    subtitle: "Business Development & Strategy ",
    content: `Adam brings expertise in business strategy, tech innovation, and venture capital to Apta. With a background in industrial engineering, he’s led capital raises for startups and founded companies serving 30+ UAE restaurants and 50+ engineers.`,
    icon: adam,
    href: "https://www.linkedin.com/in/adam-liusie-54195b151/",
  },
];

export const CONTENTS2 = [
  {
    id: 1,
    title: "James Ryan",
    subtitle: "CEO Hero Browser",
    content: `Formerly CEO of three tech startups he founded and marketing head for the <span class="font-bold">Brave</span> browser and <span class="font-bold">Hotspot Shield</span> VPN (now Pango).  Early on he was a tech writer and editor for the <span class="font-bold">New York Times</span> and <span class="font-bold">Business 2.0</span>  among others.  Most recently he ran marketing for AI image startup <span class="font-bold">BlueWillow.ai</span>.`,
    icon: jamesRayan,
    href: "https://www.linkedin.com/in/james-ryan-86b6431/",
    company: {
      src: brave,
      width: 69,
      height: 28,
    },
  },
  {
    id: 2,
    title: "Tadas Maurukas",
    subtitle: "Hero Lead",
    content: `12+ years of experience in data-driven marketing and creative strategies, generating $1 billion in value. His business development includes partnerships with brands like  <span class="font-bold"> Samsung, Polygon, Binance Smart Chain </span> , and more. Notable achievements: founding <span class="font-bold"> Blockchain Centre </span> , selling <span class="font-bold"> Lympo </span>, establishing the concept and brand for <span class="font-bold"> Anichess </span>.`,
    icon: tadas,
    href: "https://www.linkedin.com/in/maurukas/",
    company: {
      src: anim,
      width: 49,
      height: 28,
    },
  },

  {
    id: 3,
    title: "Ada Jonuse",
    subtitle: "Head of BD & Investor relations",
    content: `Serial web3 entrepreneur with an exit of a <span class="font-bold">  GameFI startup Lympo </span>  to   <span class="font-bold"> Animoca Brands </span>. A recognized thought leader, speaker and award winner. Consulted and advised dozens of web3 startups as Partner at <span class="font-bold"> Blockchain Centre</span>. Mentor of deep tech startups and expert investor in various organisations.`,
    icon: ada,
    href: "https://www.linkedin.com/in/ada-jonuse/",
    company: {
      src: anim,
      width: 49,
      height: 28,
    },
  },
  {
    id: 4,
    title: "Brandon Crosbie",
    subtitle: "Director of Data Engineering",
    content: `Brandon, a  <span class="font-bold"> Penn State  </span> renewable energy master's graduate and University of Texas Electrical Engineer, excels in data analytics and software development across multiple industries, `,
    icon: brandon,
    href: "https://www.linkedin.com/in/fullstackdatascience/",
    company: {
      src: verizon,
      width: 67,
      height: 16,
    },
  },

  {
    id: 5,
    title: "Gintautas Nekrosius",
    subtitle: "Head of Growth",
    content: `A master growth hacker,   Gintautas orchestrated over $100 million in successful token sales and led <span class="font-bold"> Atlas VPN </span>  from inception to 5 million downloads. Previously  <span class="font-bold">  CEO</span>  at  <span class="font-bold">  Blockchain Centre</span>, CMO at several startups.`,
    icon: gin,
    href: "https://www.linkedin.com/in/gintautas-nekrosius/",
    company: {
      src: atlas,
      width: 84,
      height: 26,
    },
  },
  {
    id: 6,
    title: "Dominic Rohde",
    subtitle: "Head of Talent",
    content: `<span class="font-bold">Dominic </span>is a seasoned talent leader with a strong background in blockchain and crypto recruitment. He’s driven major team expansions at REIT Development & Coinvesting and Minterest, hiring CEOs and senior roles to support rapid growth. His expertise makes him invaluable to Hero.io’s talent strategy.`,
    icon: dominicRohde,
    href: "https://www.linkedin.com/in/dominicrohde/",
    // company: {
    //   src: war,
    //   width: 57,
    //   height: 27,
    // },
  },
  {
    id: 7,
    title: "Carlos Encarnacion",
    subtitle: "Web Reputation Specialist",
    content: `<span class="font-bold">Carlos </span> Carlos is a skilled Web Reputation Specialist with over 10 years in client support and data analysis, having advised and assisted clients at Amazon and IBM. His experience in managing client relationships, analyzing feedback trends, and resolving issues equips him to expertly safeguard and enhance Hero.io’s online reputation.`,
    icon: carlosEncarnacion,
    href: "https://www.linkedin.com/in/carlos-encarnacion-27331896/",
    // company: {
    //   src: war,
    //   width: 57,
    //   height: 27,
    // },
  },
  {
    id: 8,
    title: "Nadzeya Sankovich",
    subtitle: "Communications Lead",
    content: `A seasoned communications expert, featured in Forbes, Daily Mail, and Fortune, with extensive expertise in PR, social media, marketing, and branding.`,
    icon: nadzeya,
    href: "https://www.linkedin.com/in/nadzeya-sankovich/",
    // company: {
    //   src: war,
    //   width: 57,
    //   height: 27,
    // },
  },
  {
    id: 9,
    title: "Wayne De Leon",
    subtitle: "Web Reputation Specialist",
    content: `With extensive experience in Sales, Marketing, and Social Media Management,<span class="font-bold">Wayne </span>  specializes in enhancing brand presence in the cryptocurrency market. Having navigated two bull runs, he leverages strategic thinking and relationship-building to drive digital growth and global engagement.`,
    icon: wayneDeLeon,
    href: "https://www.linkedin.com/in/wldl/",
    // company: {
    //   src: war,
    //   width: 57,
    //   height: 27,
    // },
  },
  {
    id: 10,
    title: "Rich Robinson",
    subtitle: "Advisor",
    content: `Entrepreneur-in-Residence at Animoca Brands, focused on digital asset empowerment. 
Co-founded 8 startups and supported many more as an investor, advisor, or mentor (HAX, Orbit/Chinaccelerator & 500). 
Previously led three companies from private to public and founded five, with three acquired by public firms.`,
    icon: richRobinson,
    href: "https://www.linkedin.com/in/richardrobinson/", 
    company: {
      src: anim,
      width: 49,
      height: 28,
    },
  },
  {
    id: 11,
    title: "Paulius Vaitkevičius",
    subtitle: "Advisor",
    content: `<span class="font-bold">Paulius </span> is a legal counsel with 9+ years of experience in finance, regulatory compliance, and the Web3 space. Previously with top Baltic law firm Ellex, he has advised Fortune 500 and FTSE 100 companies, including IBM, Revolut, Quaero Capital, Apollo Global Management, and Telia. He is currently focused on Web3 and financial services.`,
    icon: paulius,
    // href: "https://www.linkedin.com/in/wldl/", //wrong
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 12,
    title: "Sergej",
    subtitle: "Browser Developer",
    content: `<span class="font-bold">Sergej </span> is an experienced software engineer with 15+ years in the Chromium open source project, specializing in Chromium and Brave codebases. Skilled in building browsers, optimizing performance, and managing upstream merges. Currently serving as Lead Developer for Chromium/Browser at Hero.io.`,
    icon: dafault,
    // href: "https://www.linkedin.com/in/wldl/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 13,
    title: "Adi",
    subtitle: "Creative Director",
    content: `<span class="font-bold" >Adi </span> is a dynamic creative force with expertise spanning Visual Design, Animation, VFX, AR/VR, Audio, and Branding. His collaborations with renowned brands like Marvel, DC, and Comicave showcase his talent for creating immersive content and visually stunning experiences. Aditya’s innovative approach bridges creativity and technology, bringing bold ideas to life.`,
    icon: adi,
    href: "https://www.linkedin.com/in/aditya-rajgopal-524376195/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 14,
    title: "Akash",
    subtitle: "VFX Generalist & Motion Design",
    content: `<span class="font-bold" >Akash </span> is a VFX and motion design expert with experience creating visuals for Disney and Web3TV Productions. Proficient in 2D/3D graphics using tools like Adobe After Effects and Unreal Engine, he brings precision and creativity to digital media.`,
    icon: akash,
    href: "https://www.linkedin.com/in/akashdeep-mathur-5a61971b5/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  // {
  //   id: 15,
  //   title: "Ned Zimin",
  //   subtitle: "Product Designer",
  //   content: `With a strong background in crypto and finance design, <span class="font-bold" >Ned </span> has led product design at Hero.io since 2024, focusing on the Hero.io wallet’s user experience. Previously, he worked with industry leaders like Paysafe Group and AEternity Blockchain, where he developed seamless integrations for cryptocurrency, stock, and DeFi solutions.`,
  //   icon: nedzimin,
  //   href: "https://www.linkedin.com/in/nedzimin/", 
  //   // company: {
  //   //     src: anim,
  //   //     width: 49,
  //   //     height: 28,
  //   // },
  // },
  {
    id: 16,
    title: "Yousef Atout",
    subtitle: "3D Artist",
    content: `<span class="font-bold" >Yousef </span> is a seasoned 3D artist specializing in crafting immersive digital environments for games, films, and interactive media. With experience at REIT, he excels in transforming concepts into polished visuals, blending creativity with technical expertise to elevate user experiences.`,
    icon: yousefAtout,
    href: "https://www.linkedin.com/in/yousef-atout-268b65124/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 17,
    title: "Jaykrushna Rawool",
    subtitle: "Senior 3D Generalist ",
    content: ` <span class="font-bold" >Jaykrushna </span> , a dynamic industry professional 3D modeling artist with 15+ years in animation and VFX, has worked on blockbusters like Avengers: Endgame, Dune, and Zack Snyder's Justice League. Proficient in Maya, ZBrush, and Substance Painter, he excels in environment and hard surface modeling for feature films.`,
    icon: jaykrushna,
    href: "https://www.linkedin.com/in/jaykrushna-rawool-93041218/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 18,
    title: "John Melad",
    subtitle: "Senior 3D FX & Simulation Designer",
    content: `A versatile 3D designer and CG artist, <span class="font-bold" >John </span>  combines technical skill with a keen creative vision to deliver captivating product visualizations and immersive environments. With a portfolio that includes work for luxury brands like MAC Cosmetics and collaborations with top studios, he brings high-quality, detail-oriented 3D renders to life across diverse industries.`,
    icon: johnMelad,
    href: "https://www.linkedin.com/in/johnmelad/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 19,
    title: "Jason Kinyaev",
    subtitle: "Director, Hero Search",
    content: `<span class="font-bold" >Jason </span>is a technical leader with expertise in high-load web applications and blockchain security. As Director of Hero Search, he combines strategic vision with hands-on development to build scalable, secure solutions that drive performance and reliability for Hero.io.`,
    icon: jasonKinyyaev,
    // href: "https://www.linkedin.com/in/wldl/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 20,
    title: "Sergii Kovach",
    subtitle: "Senior Software Engineer",
    content: `With 10+ years of experience in .NET,<span class="font-bold" >Sergii </span>is a skilled developer specializing in C#, ASP.NET, SQL, and Angular. Having worked with SoftServe and Intech Technology, he excels in building robust applications with a focus on agile practices and Test-Driven Development (TDD).`,
    icon: sergiiKovsch,
    href: "https://www.linkedin.com/in/sergii-kovach-25607365/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 21,
    title: "Yerkebulan Yelzhan",
    subtitle: "Lead Flutter Engineer",
    content: `<span class="font-bold" >Yerkebulan </span>  is a distinguished Flutter developer with experience crafting high-quality mobile applications. At Hero.io, he leads the development of user-focused mobile solutions, building on his impactful work at Wio Bank and EPAM Systems. A WWDC20 Scholarship recipient, his expertise spans architecture design, developer tools, and mentoring.`,
    icon: yekebulan,
    href: "https://www.linkedin.com/in/yerkebulan-yelzhan-ba0267265/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 22,
    title: "Mohammad Hussein",
    subtitle: "Senior Browser Developer",
    content: `<span class="font-bold" >Mohammad </span>is a full-stack developer with 6+ years of expertise in front-end frameworks like React and back-end technologies like Node.js and Python. At Hero.io, he optimizes Hero Search's performance using microservices, Kubernetes, and GraphQL, specializing in cryptocurrency and real-time systems.`,
    icon: mohammad,
    // href: "https://www.linkedin.com/in/wldl/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 23,
    title: "Roman Novikov",
    subtitle: "Data Engineer",
    content: `<span class="font-bold" >Roman </span> is a Software Engineer specializing in data pipelines, automation, and cloud solutions. He has led projects improving efficiency by 40% and reducing errors by 30%, delivering scalable, reliable systems with modern technologies. Experienced in team collaboration and workflow management, he is passionate about leveraging technology to drive performance.`,
    icon: romanNovikov,
    href: "https://www.linkedin.com/in/r-novikov/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 24,
    title: "Lucas Guimarães",
    subtitle: "Senior Data Engineer",
    content: `With 4+ years in backend development,<span class="font-bold" >Lucas </span> specializes in scalable services and data engineering with Python, SQL, and Apache Kafka. An expert in computer vision and machine learning, he has led impactful projects in video processing and system optimization, including a government-deployed computer vision system in Brazil.`,
    icon: lucasGuimaraes,
    href: "https://www.linkedin.com/in/lucas-h-s-guimaraes/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 25,
    title: "Hamza Wahab",
    subtitle: "Data Researcher",
    content: `A skilled Data Researcher with over 3 years of experience in blockchain analytics and decentralized data solutions, Hamza combines strong analytical skills with a commitment to transparency and innovation. Proficient in SQL, Excel, and market research, he drives impactful data insights to support the future of decentralized technology.`,
    icon: hamzaWahab,
    href: "https://www.linkedin.com/in/hamzawahab/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 26,
    title: "Flaviu Bura",
    subtitle: "Senior Flutter Engineer",
    content: `<span class="font-bold" >Flaviu </span> is a skilled Flutter developer with expertise in Dart, CI/CD pipelines, and data management. He has led teams to build health care and e-commerce apps, delivering user-focused, scalable, and secure solutions. Known for optimizing efficiency and quality, he drives innovation through rigorous code reviews, testing, & advanced architecture design.`,
    icon: flaviu,
    href: "https://www.linkedin.com/in/flaviu-bura-544444184/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 27,
    title: "Dmitri Verovski",
    subtitle: "Senior Product Designer",
    content: `<span class="font-bold" >Verovski </span>, a Senior Product Designer at Sidekick Browser, specializes in UX, UI, and brand development. With experience in fintech, gaming, and blockchain, he’s led award-winning designs and major product launches for brands like FinchPay and BASIS ID. Based in Tallinn, Dmitri is fluent in Russian and English.`,
    icon: domitri,
    href: "https://www.linkedin.com/in/verovski/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 28,
    title: "Roman Kulik",
    subtitle: "Senior DevOps Engineer",
    content: `<span class="font-bold" >Roman Kulik  </span>is an experienced DevOps and infrastructure leader specializing in secure, scalable systems for companies like OPTIC and DexGuru. Skilled in AI services, blockchain infrastructure, and IT architecture, he has led key projects, secured Tier 1 contracts, and implemented blockchain integrations in the Web3 space.`,
    icon: romanKulik,
    href: "https://www.linkedin.com/in/roman-kulik/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 29,
    title: "Muhammad Furqan Arshad",
    subtitle: "Data Researcher",
    content: `<span class="font-bold" >Muhammad Furqan Arshad </span> is a Data Researcher in Dubai specializing in cryptocurrency. He analyzes complex data to uncover trends and insights, using skills in data mining, analysis, using tools like Excel, CRM Management, and blockchain.`,
    icon: mohammadFurqan,
    href: "https://www.linkedin.com/in/muhammad-furqan-arshad-b5a03913b/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 30,
    title: "Kapustin Iaroslav",
    subtitle: "Flutter Engineer",
    content: `<span class="font-bold" >Kapustin </span> is a Senior Fullstack Developer based in Pavlodar,  specializing in Flutter and Dart for mobile and web applications. With extensive experience in both frontend and backend development, he has led multiple projects, including real estate and streaming platforms, and is adept in CI/CD practices and cloud computing technologies.`,
    icon: kapustin,
    href: "https://www.linkedin.com/in/iaroslav-kapustin-49246b195/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 31,
    title: "Roman Stratev",
    subtitle: "Senior Back End Engineer ",
    content: `<span class="font-bold" >Roman </span> is a seasoned backend developer with over 7 years of experience leading high-load projects and building scalable systems. With expertise in PHP, Kotlin, and Go, he excels in system architecture, microservices, and process optimization. Roman brings his technical leadership and problem-solving skills to enhance the performance and reliability of Hero Search.`,
    icon: romanStratev,
    href: "https://www.linkedin.com/in/roman-stratiev/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 32,
    title: "Ahmed Usman",
    subtitle: "Data Researcher",
    content: `<span class="font-bold" >Ahmed </span>, a skilled data researcher, excels in data management and customer service with experience at Emirates Post Office, AL Futtaim Health Hub, and Amazon. Renowned for his accuracy, multilingual skills, and problem-solving, he delivers precision and adaptability to every project.`,
    icon: ahmadUsman,
    href: "https://www.linkedin.com/in/ahmed-usman-62448b124/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 33,
    title: "Muhammed Usama",
    subtitle: "Data Researcher",
    content: `<span class="font-bold" >Usama </span> is a detail-oriented Data Researcher with a strong foundation in legal analysis and financial management. With experience as a Research Analyst at Benelux Tek Group and as a Cash Flow Manager at Ibrahimi Group, he brings expertise in market research, CRM management, and financial forecasting to Hero.io, enhancing data-driven decision-making.`,
    icon: mohammadUsama,
    href: "https://www.linkedin.com/in/usama-wahab-91771a255/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 34,
    title: "Muzzamil Amin",
    subtitle: "Data Researcher",
    content: `<span class="font-bold" >Muzammil </span> is a diligent and communicative Data Researcher with a strong foundation in customer service and operational efficiency. Known for his determination and team-oriented approach, has experience assisting in management roles and engaging with clients. He has contributed to data entry for hospitals and pharmacies, ensuring accurate data handling and compliance.`,
    icon: muzzamil,
    href: "https://www.linkedin.com/in/muzammil-amin-2591b9192/", 
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
  {
    id: 35,
    title: "Abdullah Shaheer",
    subtitle: "Lead Business Analytics",
    content: `With a proven track record in e-commerce data and SEO,<span class="font-bold" >Abdullah </span>  leads analytics at Hero.io to drive strategic growth. Previously with Mobit Solutions, he bridges business and tech to ensure data-driven decisions that boost performance and user engagement.`,
    icon: abdullah,
    href: "https://www.linkedin.com/in/abdullah-shaheer-5121b4232/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },

  {
    id: 36,
    title: "Nejc Dobrila",
    subtitle: "Social Media Lead",
    content: `A seasoned Web3 marketing professional with 5+ years of experience who built and managed communities of over 200,000+ members across multiple platforms. Previously led social media strategies for multiple Web3 companies, including a major cryptocurrency exchange. Skilled in creating viral content with a proven track record of driving authentic engagement and organic growth.`,
    icon: nejc,
    // href: "https://www.linkedin.com/in/abdullah-shaheer-5121b4232/",
    // company: {
    //     src: anim,
    //     width: 49,
    //     height: 28,
    // },
  },
];
